import { Subject } from 'rxjs'

const _layerControlsVisible$ = new Subject<boolean>()
export const layerControlsVisible$ = _layerControlsVisible$.asObservable()

export const setLayerControlsVisible = (visible: boolean): void => {
    _layerControlsVisible$.next(visible)
}
